import React from 'react';

// STYLES
import * as S from '../../../Establishment/ListEstablishment/styles';
import { BoxSearch, Input, InputBox, SearchIconButton } from './styles';
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  FormLabel,
  FormControlLabel,
  Checkbox,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tooltip,
} from '@mui/material';

// COMPONENTES
import { GoBackHeader } from '../../CreateClub/RelationshipClub/GoBackHeader';
import { HeaderTitle } from '../../CreateClub/RelationshipClub/HeaderTitle';
import CustomButtonsTable from 'js/components/TriiboComponents/Tables/CustomButtonsTable';

// ICONES
import { AddPhotoAlternate } from '@mui/icons-material';
import SendIcon from '@mui/icons-material/Send';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import searchIcon from 'styles/assets/SearchUser/search.svg';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PartnerChip from './PartnerChip';

export default function View({
  form,
  setForm,
  handleChangeFields,
  handleChangeCheckbox,
  checkboxMessage,
  checkedItems,
  clubKey,
  renderInputByClubKey,
  renderInputEstablishment,
  origin,
  errorMessage,
  file,
  handleFileButtonClick,
  fileChangedHandler,
  data,
  searchTerm,
  handleSearch,
  filteredResults,
  column,
  componentReceiver,
  loadingButton,
  handleSubmit,
}) {
  // hora do date picker
  const formatToLocalISO = (date) => {
    const localDate = new Date(date);
    localDate.setMinutes(localDate.getMinutes() - localDate.getTimezoneOffset());
    return localDate.toISOString().slice(0, 16);
  };

  // para obter a data atual formatada no padrão ISO para datetime-local
  const getCurrentISO = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    return now.toISOString().slice(0, 16);
  };

  return (
    <>
      <Box sx={{ paddingBottom: '10rem' }}>
        <S.Container>
          <GoBackHeader />
          <HeaderTitle pageInfo="Enviar Notificação" />

          <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <TextField
                fullWidth
                id="notificationDate"
                label="Selecione data e hora em que a notificação será disparada:"
                type="datetime-local"
                value={form.notificationDate ? formatToLocalISO(form.notificationDate) : ''}
                onChange={handleChangeFields}
                onFocus={(e) => e.target.showPicker()} // para fazer com que o datepicker abra ao clicar no campo
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: getCurrentISO(),
                }}
                color="primary"
                required
              />

              <TextField
                fullWidth
                required
                type="text"
                value={form.title}
                id="title"
                label="Titulo"
                onChange={handleChangeFields}
              />
              <TextField
                fullWidth
                required
                multiline
                type="text"
                value={form.message}
                id="message"
                label="Mensagem"
                onChange={handleChangeFields}
              />

              <PartnerChip setForm={setForm} origin={origin} />

              <FormControl>
                {checkboxMessage !== '' && (
                  <Typography color="red" variant="subtitle1" sx={{ marginTop: '5px' }}>
                    {checkboxMessage}
                  </Typography>
                )}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems.item1}
                        onChange={handleChangeCheckbox}
                        name="item1"
                      />
                    }
                    label="Lista de membros da postagem"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={checkedItems.item2}
                        onChange={handleChangeCheckbox}
                        name="item2"
                      />
                    }
                    label="Lista de usuário direcionada"
                  />
                </Box>
              </FormControl>
            </Box>

            {checkedItems.item2 && (
              <Accordion sx={{ marginTop: '20px' }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Lista de usuários
                </AccordionSummary>

                <AccordionDetails>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '20px',
                    }}
                  >
                    {clubKey ? renderInputByClubKey(clubKey) : renderInputEstablishment()}

                    <Tooltip
                      title={
                        origin === 'club'
                          ? 'Atenção! Só é possível adicionar membros desse clube.'
                          : 'Atenção! Só é possível adicionar usuários que possuem relação com o estabelecimento.'
                      }
                      placement="top"
                    >
                      <span>
                        <HelpOutlineIcon sx={{ color: '#b1aeae' }} />
                      </span>
                    </Tooltip>
                  </Box>

                  {errorMessage !== '' && (
                    <Typography color="red" variant="subtitle2" sx={{ marginTop: '5px' }}>
                      {errorMessage}
                    </Typography>
                  )}

                  <FormLabel component="legend" sx={{ marginTop: '40px' }}>
                    Arquivo com a lista de usuários{' '}
                    {origin === 'club' && clubKey
                      ? `(chave: ${clubKey}) - Exemplo: `
                      : '- Exemplo: '}
                    {(() => {
                      switch (clubKey) {
                        case 'cellPhone':
                          return '+5511000000000';
                        case 'cpf':
                          return '43911929909';
                        case 'email':
                          return 'example@triibo.com.br';
                        case 'cnpj':
                          return '31959924000143';
                        default:
                          return '+5511000000000';
                      }
                    })()}
                    <br />
                    Precisa ser no formato .txt ou .csv
                  </FormLabel>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '10px',
                    }}
                  >
                    <input
                      id="usersList"
                      accept=".txt"
                      style={{ display: 'none' }}
                      type="file"
                      onChange={fileChangedHandler}
                    />
                    <label
                      htmlFor="usersList"
                      style={{
                        display: 'flex',
                        gap: '20px',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        sx={{ textTransform: 'capitalize', fontWeight: '550' }}
                        variant="contained"
                        color="secondary"
                        startIcon={<AddPhotoAlternate />}
                        onClick={handleFileButtonClick}
                      >
                        Adicionar Arquivo
                      </Button>
                      {file && (
                        <Box sx={{ fontSize: '14px' }}>
                          <b>Arquivo selecionado: </b>
                          {file.name}
                        </Box>
                      )}
                    </label>
                  </Box>

                  {data.length > 0 ? (
                    <>
                      <BoxSearch style={{ width: '100%', marginTop: '60px' }}>
                        <InputBox style={{ borderBottom: '1px solid #ccc' }}>
                          <Input
                            placeholder="Pesquisar usuário..."
                            onChange={handleSearch}
                            value={searchTerm}
                          />
                          <SearchIconButton onClick={(e) => e.preventDefault()}>
                            <img src={searchIcon} alt="" />
                          </SearchIconButton>
                        </InputBox>
                      </BoxSearch>

                      {filteredResults.length > 0 ? (
                        <Box sx={{ marginTop: '20px' }}>
                          <CustomButtonsTable
                            data={filteredResults}
                            column={column}
                            perPage={10}
                            componentReceiver={componentReceiver}
                            loadingTableDisabled={true}
                          />
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
                          <strong>Nenhum resultado encontrado.</strong>
                        </Box>
                      )}
                    </>
                  ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', margin: '40px 0px' }}>
                      <strong>Nenhum usuário adicionado.</strong>
                    </Box>
                  )}
                </AccordionDetails>
              </Accordion>
            )}

            <Button
              sx={{
                marginTop: '40px',
                color: 'white',
                textTransform: 'capitalize',
                fontWeight: '550',
              }}
              variant="contained"
              color="primary"
              type="submit"
              startIcon={!loadingButton && <SendIcon size={10} />}
              disabled={loadingButton}
              onClick={handleSubmit}
            >
              {loadingButton ? (
                <CircularProgress size={25} thickness={6} sx={{ color: '#fff' }} />
              ) : (
                'Enviar'
              )}
            </Button>
          </Box>
        </S.Container>
      </Box>
    </>
  );
}
